import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UsersService } from '../../../api/users.service';
import { UserService } from "../../../data/user/user.service";

@Component({
    selector: 'app-welcome-message-popup',
    templateUrl: './welcome-message-popup.component.html',
    styleUrls: ['./welcome-message-popup.component.scss'],
    standalone: false
})
export class WelcomeMessagePopupComponent implements OnInit {
  firstName = '';
  showWelcomeMessagePopup = false;

  constructor(
    public dialogRef: MatDialogRef<WelcomeMessagePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public userPreference: boolean,
    private userService: UserService,
    public userApi: UsersService) {
  }

  ngOnInit(): void {
    this.firstName = this.userService.loggedInUser.firstName.split(/[ ,]/)[0];
  }

  saveUserPreference(): void {
    this.dialogRef.close();
    //saving the preference in database
    this.userApi.updateUserPreference(this.showWelcomeMessagePopup).subscribe(res => {
    });
  }

  toggleUserPreference(): void {
    this.showWelcomeMessagePopup = !this.userPreference;
    this.userService.userPreference = !this.userService.userPreference;
  }

  getChecked(): boolean {
    return this.userPreference ? true : false;
  }
}
